import accountsPayable from './accountsPayable';
import checkoutScreen from './checkout';
import deleted from './deleted';
import notFound from './notFound';

export default {
  translation: {
    common: {
      oysterCheckout: 'Oyster Pagos',
      messages: {
        useOyster:
          'Si quieres saber cómo habilitar métodos de pago para tu negocio o plataforma, visita <0>Oyster</0>',
        useOysterPayments:
          '¿Tienes un negocio? Crea links de pago con Oyster y aumenta tus ventas <0>aquí</0>. ',
      },
      labels: {
        continue: 'Continuar',
      },
      tooltip: {
        copied: 'Copiado',
      },
      footer: {
        getApp: 'Descarga la app',
        copyright: 'Oyster Financial. Algunos Derechos Reservados.',
        tnc: 'Aviso de Privacidad',
      },
      createAccount: {
        title: '¿Tienes un negocio?',
        message: 'Abre una cuenta Oyster sin costo y obtén:',
        steps: [
          'Link de pago para cobrar en línea',
          'Crédito para negocios pequeños',
          'Transferencias SPEI 24/7 sin comisiones',
          'Tarjeta de débito Oyster Mastercard',
        ],
        button: 'Abrir mi cuenta',
      },
      flags: {
        mx: 'México',
        us: 'Estados Unidos',
        ca: 'Canadá',
      },
    },
    checkoutScreen,
    deleted,
    notFound,
    accountsPayable,
  },
};
